import { render, staticRenderFns } from "./MenuDashBoard.vue?vue&type=template&id=43aadeff&scoped=true"
import script from "./MenuDashBoard.vue?vue&type=script&lang=js"
export * from "./MenuDashBoard.vue?vue&type=script&lang=js"
import style0 from "./MenuDashBoard.vue?vue&type=style&index=0&id=43aadeff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43aadeff",
  null
  
)

export default component.exports